import { FC } from 'react';
export function getCurrencySymbol(code: string) {
  switch (code) {
    case 'CLP':
    case 'USD':
      return '$';
    case 'AUD':
      return 'AU$';
    case 'HKD':
      return 'HK$';
    case 'CAD':
      return 'CA$';
    case 'SGD':
      return 'S$';
    case 'MXN':
      return 'Mex$';
    case 'NZD':
      return 'NZ$';
    case 'EUR':
      return '€';
    case 'GBP':
      return '£';
    case 'JPY':
    case 'CNY':
      return '¥';
    case 'CHF':
      return '₣';
    case 'RUB':
      return '₽';
    case 'DKK':
    case 'NOK':
    case 'SEK':
      return 'KR';
    case 'CZK':
    case 'CSK':
      return 'Kč';
    case 'PLN':
      return 'zł';
    case 'ZAR':
      return 'R';
    case 'HUF':
      return 'Ft';
    case 'ILS':
      return '₪';
    case 'TRY':
      return '₺';
    case 'BRL':
      return 'R$';
    case 'PEN':
      return 'S/.';
    default:
      return code;
  }
}

export const CurrencySymbol: FC<{ code: string }> = ({ code }) => getCurrencySymbol(code);
